module.exports = __webpack_public_path__ + "static/media/PACKING2.8ba165b4.mp4";